<aionz-generic-purchase-request-dialog
  [id]="data.id"
  [title]="data.title"
  [description]="data.description"
  [requestedAt]="data.requestedAt"
  [showDeclineButton]="false"
  [disableApproveButton]="approvalPending"
  approveButtonText="Confirmar"
  (onCancel)="cancel()"
  (onApprove)="approve()">
  <aionz-purchase-request-status
    headerStatus
    [status]="data.status" />
  <span
    class="normal-text"
    headerRequestedAt
    >Solicitado em: {{ data.requestedAt | date: 'dd/MM/yy' }}</span
  >
  <seed-card-table
    tableContent
    [scrollOnOverflow]="true">
    <seed-card-table-header>
      <div class="flex-row space-between items-center">
        <div class="flex-row gap-8 items-center"></div>
      </div>
    </seed-card-table-header>

    <seed-card-table-body>
      <table
        mat-table
        [dataSource]="dataSource()"
        matSort>
        <ng-container matColumnDef="requestedAt">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Data da Solicitação
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            <p>{{ row.requestedAt | date: 'dd/MM/yy HH:mm' : '' : 'pt-BR' }}</p>
          </td>
        </ng-container>

        <ng-container matColumnDef="fileName">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Nome do arquivo
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            <div class="flex-row items-center gap-8">
              <img
                [ngSrc]="'assets/icons/excel-icon.svg'"
                [width]="25"
                [height]="22"
                alt="excel-icon" />
              <span>{{ row.file.name }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="requester">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Solicitante
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            <div class="flex-row items-center gap-8">
              <seed-user-avatar
                [size]="24"
                [src]="row.requester.avatarUrl" />
              <span>{{ row.requester.name }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Status
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            <mat-basic-chip
              class="custom-status-chip"
              [class]="getStatusClass(row.status)">
              <span>{{ row.status }}</span>
            </mat-basic-chip>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            Ações
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                (click)="downloadFile(row.id)">
                <div class="flex-row items-center gap-8">
                  <mat-icon>download</mat-icon>
                  <span>Baixar arquivo</span>
                </div>
              </button>
              @if (row.status === 'Pendente') {
                <button
                  mat-menu-item
                  (click)="approveItem(row)">
                  <mat-icon>check</mat-icon>
                  <span>Aceitar</span>
                </button>
                <button
                  mat-menu-item
                  (click)="declineItem(row)">
                  <mat-icon>close</mat-icon>
                  <span>Recusar</span>
                </button>
              }
              @if (row.status === 'Aceita') {
                <button
                  mat-menu-item
                  (click)="declineItem(row)">
                  <mat-icon>close</mat-icon>
                  <span>Recusar</span>
                </button>
              }

              @if (row.status === 'Recusado') {
                <button
                  mat-menu-item
                  (click)="approveItem(row)">
                  <mat-icon>check</mat-icon>
                  <span>Aceitar</span>
                </button>
                <button
                  mat-menu-item
                  (click)="changeDeclineReason(row)">
                  <mat-icon>edit</mat-icon>
                  <span>Mudar motivo</span>
                </button>
              }
            </mat-menu>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"></tr>

        <tr
          class="mat-row"
          *matNoDataRow>
          <td
            class="mat-cell text-center py-3"
            colspan="8">
            Nenhum dado encontrado!
          </td>
        </tr>
      </table>
    </seed-card-table-body>
  </seed-card-table>
</aionz-generic-purchase-request-dialog>
